import api from '../module/payment-panel/shared/service/config';

export default async function putWithToken(token, path, body) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(body)
    };
    const response = await fetch(api + path, requestOptions)
    const result = await response.json();
    return result;

}
